<template>
  <div v-if="page" v-html="page" :class="['static-page-content', hiddenSeoBlock ? 'hidden-seo-block' : null]" />
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'StaticPageContent',
  mixins: [
    methods
  ],
  props: {
    slug: {
      type: String,
      required: true
    },
    hiddenSeoBlock: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      page: null
    }
  },
  mounted () {
    this.getPage()
  },
  methods: {
    setPage (data) {
      const description = data.meta.description
      const keywords = data.meta.keywords
      const keywordsMeta = document.querySelector('meta[name="keywords"]')
      const descriptionMeta = document.querySelector('meta[name="description"]')
      const descriptionOgMeta = document.querySelector('meta[property="og:description"]')
      const config = this.$config
      this.page = data.content
        .replace(/{{years}}/g, new Date().getFullYear() - 1990)
        .replace(/{{blog}}/g, config.blog)
        .replace(/{{software}}/g, config.mainSite)
      this.$nextTick(() => {
        document.querySelectorAll('.static-page-content a').forEach(link => {
          link.classList.add('white--text')
          if (link.hasAttribute('data-route')) {
            link.onclick = (event) => {
              const path = link.getAttribute('href')
              event.preventDefault()
              if (path !== this.$route.path) {
                this.$router.push({path})
              }
            }
          }
        })
      })
      if (keywordsMeta) {
        keywordsMeta.setAttribute('content', keywords.join(', '))
      }
      if (descriptionMeta) {
        descriptionMeta.setAttribute('content', description)
      }
      if (descriptionOgMeta) {
        descriptionOgMeta.setAttribute('content', description)
      }
    },
    getPage () {
      const slug = this.$route.path
      const cachedData = this.retrieveCachedData('static', slug)
      if (cachedData) {
        return this.setPage(cachedData)
      }
      this.$http({
        url: this.getRoute('page').url,
        method: 'POST',
        data: {
          slug: this.slug
        }
      }).then(response => {
        const code = response.data.code
        if (code === 0) {
          const data = response.data.data
          this.setPage(data)
          this.cacheData(slug, 'static', response.data.data)
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>
<style>
.hidden-seo-block
{
  position: fixed;
  clip: rect(0 0 0 0);
  pointer-events: none;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/static-page-content.vue